import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap } from '../../components';
import { useParams } from 'react-router';
import PsychologyPromptForm from './PsychologyPromptForm';

export default function CreatePsychologyPromptScreen() {
  const { weekNumber, weekId } = useParams();

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Create Psychology Prompt"
          items={[
            {
              name: `Program Week ${weekNumber}`,
              url: `/program/${weekNumber}/${weekId}/psychology-prompts`,
            },
          ]}
        />
        <PsychologyPromptForm existing={undefined} />
      </Stack>
    </ScreenWrap>
  );
}
